<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<Error403 v-if="research.status == 0" />

			<Maintenance v-else-if="research.status == 2" />

			<div v-else-if="research.status == 1">
				<LayoutTitle :research="research" />
				<LayoutPattern :research="research" />
			</div>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import BaseLoading from "@/components/item/BaseLoading.vue";

import Error403 from "@/components/system/Page403.vue";
import Maintenance from "@/components/system/PageMaintenance.vue";

import Meta from "@/mixins/MetaSettable";

export default {
	mixins: [Meta],
	components: {
		LayoutTitle,
		LayoutPattern,
		BaseLoading,
		Error403,
		Maintenance
	},
	data() {
		return {
			research: [],
			pageActive: false,
			loading: true
		};
	},

	created() {
		this.axios.get("/json/research.json").then(response => {
			this.research = response.data.research;
			this.loading = false;
			this.pageActive = true;
		});
	},

	mounted() {
		this.$ga.page("/research");
	}
};
</script>

<style lang="scss">
</style>